export default {
  getProfile (state) {
    return state.profile
  },
  getIntegrations (state) {
    return state.integrations
  }
}
